import { render } from "./ShowEventDialogg.vue?vue&type=template&id=8233b358&scoped=true"
import script from "./ShowEventDialogg.vue?vue&type=script&lang=js"
export * from "./ShowEventDialogg.vue?vue&type=script&lang=js"

import "./ShowEventDialogg.vue?vue&type=style&index=0&id=8233b358&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8233b358"]])

export default __exports__